(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sj-article-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sj-article-offer')) {
    class SjArticleOffer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.form = this.querySelector('form');
        this.addButton = this.querySelector('[data-sj-article-add]');
        this.status = this.querySelector('[data-sj-article-status]');
        this.error = this.querySelector('[data-sj-article-error]');
        this.form?.addEventListener('submit', (event) => {
          if (event.submitter !== this.addButton) return;
          event.preventDefault();
          this.addToCart();
        });
        this.querySelector('[data-sj-article-buy]')?.addEventListener('click', () => {
          this.track('blog_offer_buy_now');
        });
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.track('blog_offer_view');
          observer.disconnect();
        }, { threshold: 0.4 });
        observer.observe(this);
      }

      async addToCart() {
        this.addButton.disabled = true;
        this.status.hidden = true;
        this.error.hidden = true;
        try {
          const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(this.form)
          });
          if (!response.ok) throw new Error('add_to_cart_failed');
          await response.json();
          const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((result) => result.json());
          document.querySelectorAll('.cart-count').forEach((count) => {
            count.textContent = count.classList.contains('cart-count-drawer') ? `(${cart.item_count})` : cart.item_count;
          });
          this.status.hidden = false;
          this.track('blog_offer_add_to_cart');
        } catch (error) {
          this.error.hidden = false;
        } finally {
          this.addButton.disabled = false;
        }
      }

      track(eventName) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          article_handle: this.dataset.articleHandle,
          ecommerce: {
            currency: this.dataset.currency,
            value: Number(this.dataset.price || 0),
            items: [{
              item_id: this.dataset.productId,
              item_variant: this.dataset.variantId,
              item_name: this.dataset.productTitle,
              item_category: 'Article primary offer',
              item_list_id: this.dataset.articleHandle,
              item_list_name: 'Article primary offer',
              price: Number(this.dataset.price || 0),
              quantity: 1
            }]
          }
        });
      }
    }

    customElements.define('sj-article-offer', SjArticleOffer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sj-article-related-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sj-related-offers')) {
    class SjRelatedOffers extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.addEventListener('submit', (event) => {
          const button = event.submitter?.closest('[data-sj-related-add]');
          if (!button) return;
          event.preventDefault();
          this.addToCart(button);
        });
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.track('blog_related_offers_view');
          observer.disconnect();
        }, { threshold: 0.35 });
        observer.observe(this);
      }

      async addToCart(button) {
        const form = button.closest('form');
        const card = button.closest('[data-product-id]');
        const status = card.querySelector('[data-sj-related-status]');
        const error = card.querySelector('[data-sj-related-error]');
        button.disabled = true;
        status.hidden = true;
        error.hidden = true;
        try {
          const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('add_to_cart_failed');
          await response.json();
          const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((result) => result.json());
          document.querySelectorAll('.cart-count').forEach((count) => {
            count.textContent = count.classList.contains('cart-count-drawer') ? `(${cart.item_count})` : cart.item_count;
          });
          status.hidden = false;
          this.track('blog_related_offer_add_to_cart', card);
        } catch (addError) {
          error.hidden = false;
        } finally {
          button.disabled = false;
        }
      }

      track(eventName, card) {
        window.dataLayer = window.dataLayer || [];
        const item = card ? {
          item_id: card.dataset.productId,
          item_variant: card.dataset.variantId,
          item_name: card.dataset.productTitle,
          item_category: 'Article related offer',
          item_list_id: this.dataset.articleHandle,
          item_list_name: 'Article related offers',
          price: Number(card.dataset.price || 0),
          quantity: 1
        } : undefined;
        window.dataLayer.push({
          event: eventName,
          article_handle: this.dataset.articleHandle,
          ecommerce: item ? {
            currency: this.dataset.currency,
            value: item.price,
            items: [item]
          } : undefined
        });
      }
    }

    customElements.define('sj-related-offers', SjRelatedOffers);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sj-calendar-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sj-calendar-offer')) {
    class SjCalendarOffer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.form = this.querySelector('form');
        this.addButton = this.querySelector('[data-sj-calendar-add]');
        this.status = this.querySelector('[data-sj-calendar-status]');
        this.error = this.querySelector('[data-sj-calendar-error]');
        this.form?.addEventListener('submit', (event) => {
          if (event.submitter !== this.addButton) return;
          event.preventDefault();
          this.addToCart();
        });
        this.querySelector('[data-sj-calendar-buy]')?.addEventListener('click', () => {
          this.track('calendar_offer_buy_now');
        });
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.track('calendar_offer_view');
          observer.disconnect();
        }, { threshold: 0.4 });
        observer.observe(this);
      }

      async addToCart() {
        this.addButton.disabled = true;
        this.status.hidden = true;
        this.error.hidden = true;
        try {
          const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(this.form)
          });
          if (!response.ok) throw new Error('add_to_cart_failed');
          await response.json();
          const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((result) => result.json());
          document.querySelectorAll('.cart-count').forEach((count) => {
            count.textContent = count.classList.contains('cart-count-drawer') ? `(${cart.item_count})` : cart.item_count;
          });
          this.status.hidden = false;
          this.track('calendar_offer_add_to_cart');
        } catch (error) {
          this.error.hidden = false;
        } finally {
          this.addButton.disabled = false;
        }
      }

      track(eventName) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          page_handle: this.dataset.pageHandle,
          ecommerce: {
            currency: this.dataset.currency,
            value: Number(this.dataset.price || 0),
            items: [{
              item_id: this.dataset.productId,
              item_variant: this.dataset.variantId,
              item_name: this.dataset.productTitle,
              item_category: 'Calendar primary offer',
              item_list_id: this.dataset.pageHandle,
              item_list_name: 'Calendar primary offer',
              price: Number(this.dataset.price || 0),
              quantity: 1
            }]
          }
        });
      }
    }

    customElements.define('sj-calendar-offer', SjCalendarOffer);
  }

  if (!window.sjCalendarReminderTracking) {
    window.sjCalendarReminderTracking = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-sj-calendar-reminder] a');
      if (!button) return;
      const reminder = button.closest('[data-sj-calendar-reminder]');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'calendar_offer_reminder_click',
        page_handle: reminder.dataset.pageHandle,
        product_id: reminder.dataset.productId
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sj-quickview-merchandising"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sj-quickview-merchandising')) {
    class SjQuickviewMerchandising extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        const quickview = this.closest('.product-quickview__content');
        const target = quickview?.querySelector('.product-single__information > div');
        const detailsLink = target?.querySelector('.product-singe__view-all-button');
        if (target && this.parentElement !== target) {
          if (detailsLink) target.insertBefore(this, detailsLink);
          else target.appendChild(this);
        }

        this.button = this.querySelector('[data-sj-quickview-add]');
        this.error = this.querySelector('[data-sj-quickview-error]');
        this.button?.addEventListener('click', () => this.addRecommendation());
      }

      async addRecommendation() {
        const button = this.button;
        if (!button || button.disabled) return;

        button.disabled = true;
        button.textContent = button.dataset.labelAdding;
        if (this.error) this.error.hidden = true;

        try {
          const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{
                id: Number(button.dataset.variantId),
                quantity: 1,
                properties: {
                  _sj_cart_role: 'recommendation',
                  _sj_cart_campaign: 'quickview_sadhana_pairings'
                }
              }]
            })
          });

          if (!response.ok) throw new Error('add_to_cart_failed');

          const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((result) => result.json());
          document.querySelectorAll('.cart-count').forEach((count) => {
            count.textContent = count.classList.contains('cart-count-drawer') ? `(${cart.item_count})` : cart.item_count;
          });

          button.textContent = button.dataset.labelAdded;
          this.track('quickview_recommendation_add');
        } catch (error) {
          button.disabled = false;
          button.textContent = button.dataset.labelDefault;
          if (this.error) this.error.hidden = false;
        }
      }

      track(eventName) {
        const button = this.button;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          ecommerce: {
            currency: this.dataset.currency,
            value: Number(button?.dataset.price || 0),
            items: [{
              item_id: button?.dataset.productId,
              item_name: button?.dataset.productTitle,
              item_category: 'Quick view sadhana recommendation',
              item_list_id: this.dataset.sourceProductId,
              item_list_name: this.dataset.sourceProductTitle,
              item_variant: button?.dataset.variantId,
              price: Number(button?.dataset.price || 0),
              quantity: 1
            }]
          }
        });
      }
    }

    customElements.define('sj-quickview-merchandising', SjQuickviewMerchandising);
  }
  } catch(e) { console.error(e); }
})();

})();
